<!-- Header -->
<header
  [ngClass]="'bg-[#FCFCFC] xl:rounded-t-2xl border-b border-gray-200'"
  class="px-4 md:px-5 py-3 lg:py-2"
>
  <div class="flex items-center justify-between">
    <!-- Left Section -->
    <div class="flex items-center space-x-3 md:space-x-4">
      <button (click)="onToggleSidebar()" class="rounded-lg hover:bg-gray-100 transition-colors">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
      </button>
      <div>
        <h1 class="text-lg md:text-xl font-bold text-gray-800">{{ currentTitle() }}</h1>
      </div>
    </div>
    <div class="flex items-center space-x-3 md:space-x-4">
      <div class="hidden sm:block w-[9.5rem] md:w-[10.5rem] [&_button]:h-8 [&_button]:min-h-8 [&_button]:text-[12px]">
        @for (_ of [selectionResetKey()]; track _) {
        <app-dropdown
          placeholder="Audit Type"
          [options]="auditTypeOptions"
          [selectedOption]="selectedAuditType()"
          [showClearButton]="false"
          (selectionChange)="onAuditTypeChange($event)"
        ></app-dropdown>
        }
      </div>
      <div class="hidden sm:block w-[11rem] md:w-[13rem] [&_button]:h-8 [&_button]:min-h-8 [&_button]:text-[12px]">
        @for (_ of [selectionResetKey()]; track _) {
        <app-dropdown
          placeholder="Select Branch"
          [options]="branchOptions()"
          [selectedOption]="selectedBranchLabel()"
          [enableSearch]="true"
          [showClearButton]="false"
          (selectionChange)="onBranchChange($event)"
        ></app-dropdown>
        }
      </div>
      <div class="absolute inset-y-0 right-2 lg:right-0 flex gap-2 sm:gap-3 md:gap-4 items-center sm:static sm:inset-auto sm:ml-6">
        <!-- Notification button and popup (ref used for outside-click close) -->
        <div class="relative" #notificationDropdownContainer>
          <button
            #notificationButton
            type="button"
            class="relative rounded-full bg-gray-100 p-1.5 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-offset-gray-800 transition-colors"
            (click)="viewNotifications()"
          >
            @if (hasUnread()) {
            <span class="flex absolute top-0 end-0 size-3 mt-0 -me-0">
              <span
                class="animate-ping absolute inline-flex size-2 rounded-full bg-red-400 opacity-75 dark:bg-red-600"
              ></span>
              <span
                class="relative inline-flex rounded-full size-2 bg-red-500"
              ></span>
            </span>
            }
            <span class="sr-only">View Notifications</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="size-5 text-gray-500"
            >
              <g fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M18.75 9.71v-.705C18.75 5.136 15.726 2 12 2S5.25 5.136 5.25 9.005v.705a4.4 4.4 0 0 1-.692 2.375L3.45 13.81c-1.011 1.575-.239 3.716 1.52 4.214a25.8 25.8 0 0 0 14.06 0c1.759-.498 2.531-2.639 1.52-4.213l-1.108-1.725a4.4 4.4 0 0 1-.693-2.375Z"
                />
                <path
                  stroke-linecap="round"
                  d="M7.5 19c.655 1.748 2.422 3 4.5 3s3.845-1.252 4.5-3"
                />
              </g>
            </svg>
          </button>

          @if (showNotifications) {
          <div
            class="fixed z-[9999] w-[380px] max-w-[calc(100vw-2rem)] origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
            [style.top]="notificationPopupPosition().top"
            [style.right]="notificationPopupPosition().right"
            role="dialog"
            aria-label="Notifications"
          >
            <div class="flex items-center justify-between border-b border-gray-100 px-4 py-3">
              <h3 class="text-base font-semibold text-gray-900">Notifications</h3>
              <button
                type="button"
                (click)="openViewAllModal()"
                class="text-sm text-gray-500 underline hover:text-gray-700"
              >
                View All
              </button>
            </div>

            <div
              class="max-h-[320px] overflow-y-auto"
              (scroll)="onNotificationsScroll($event)"
            >
              @for (item of filteredNotifications(); track item.id) {
              <div
                class="flex gap-3 border-b border-gray-100 px-4 py-3 last:border-b-0 hover:bg-gray-50/50"
                [class.cursor-pointer]="item.auditRoute"
                (click)="item.auditRoute && navigateToAudit(item.auditRoute, item.id)"
              >
                <span
                  class="mt-1.5 size-2 shrink-0 rounded-full"
                  [class.bg-red-500]="item.unread"
                  [class.invisible]="!item.unread"
                  aria-hidden="true"
                ></span>
                <div class="min-w-0 flex-1">
                  <p
                    class="text-sm text-gray-800"
                    [innerHTML]="formatNotificationMessage(item)"
                  ></p>
                  <p class="mt-0.5 text-xs text-gray-500">{{ item.time }}</p>
                </div>
              </div>
              }
              @if (loadingMoreNotifications()) {
              <div class="flex justify-center py-3">
                <div class="flex items-center gap-2 text-xs text-gray-500">
                  <span class="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-gray-600 inline-block"></span>
                  <span>Loading older notifications...</span>
                </div>
              </div>
              }
              @if (hasMoreNotifications() && !loadingMoreNotifications()) {
              <div class="flex justify-center py-2 pb-3">
                <button
                  type="button"
                  (click)="loadMoreNotifications()"
                  class="text-xs text-gray-500 hover:text-gray-700 underline"
                >
                  Load older notifications
                </button>
              </div>
              }
            </div>
          </div>
          }
        </div>

        <!-- Profile dropdown -->
        <div #userMenuContainer>
          <div>
            <button
              type="button"
              class="relative flex rounded-full p-0 lg:py-1 text-[#25282D] focus:outline-none focus:ring-white focus:ring-offset-gray-800"
              id="user-menu-button"
              aria-expanded="false"
              aria-haspopup="true"
              (click)="openUserDropdown()"
            >
              <span class="absolute -inset-1.5"></span>
              <span class="sr-only">Open user menu</span>
              <img
                class="h-8 w-8 rounded-full"
                src="\assests\profile.png"
                alt=""
              />
            </button>
          </div>
          @if (isNavUserDropdown) {
          <div
            class="absolute right-4 z-10 mt-2 w-64 max-w-[calc(100vw-2rem)] origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            tabindex="-1"
          >
            <div
              class="flex gap-2 px-4 py-2.5 h-full text-xs text-gray-900 bg-[#ede6fc]"
            >
              <img
                class="h-10 w-10 rounded-full"
                src="/assests/profile.png"
                alt="User profile"
              />
              <div class="flex flex-col justify-between h-auto min-w-0 flex-1">
                <div class="font-semibold text-[13px]">
                  @if (user(); as currentUser) {
                  {{ currentUser.firstName }} {{ currentUser.lastName }}
                  } @else { User }
                </div>
                <div class="text-[12px] break-words break-all">
                  @if (user(); as currentUser) {
                  {{ currentUser.email }}
                  } @else { user@example.com }
                </div>
              </div>
            </div>
            <ul class="py-2 border-t text-xs sm:text-[13px] text-gray-700">
              <li class="">
                <a
                  routerLink="/profile/view-profile"
                  (click)="closeUserDropdown()"
                  class="flex itesm-center gap-3 px-4 py-2 hover:text-[#6729FF] cursor-pointer"
                >
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                      />
                    </svg> </span
                  >View Profile</a
                >
              </li>
              <li>
                <a
                  href="#"
                  (click)="closeUserDropdown(); $event.preventDefault()"
                  class="flex items-center gap-3 px-4 py-2 hover:text-[#6729FF]"
                >
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg> </span
                  >Security Settings</a
                >
              </li>
            </ul>
            <div class="py-1 border-t">
              <button
                type="button"
                (click)="onLogout()"
                class="flex items-center gap-3 px-4 py-2 text-xs sm:text-[13px] text-gray-700 hover:text-[#6729FF] w-full text-left"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    class="w-4"
                  >
                    <path
                      fill="currentColor"
                      d="M5.616 20q-.691 0-1.153-.462T4 18.384V5.616q0-.691.463-1.153T5.616 4h6.403v1H5.616q-.231 0-.424.192T5 5.616v12.769q0 .23.192.423t.423.192h6.404v1zm10.846-4.461l-.702-.72l2.319-2.319H9.192v-1h8.887l-2.32-2.32l.702-.718L20 12z"
                      stroke-width="1"
                      stroke="currentColor"
                    />
                  </svg>
                </span>
                Sign out
              </button>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- View All Notifications Modal -->
  @if (showViewAllModal) {
  <div
    class="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/50"
    role="dialog"
    aria-modal="true"
    aria-labelledby="view-all-modal-title"
    (click)="closeViewAllModal()"
  >
    <div
      class="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between border-b border-gray-200 px-5 py-4">
        <h2 id="view-all-modal-title" class="text-lg font-semibold text-gray-900">All Notifications</h2>
        <button
          type="button"
          (click)="closeViewAllModal()"
          class="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div
        class="flex-1 overflow-auto px-2 py-2"
        (scroll)="onNotificationsScroll($event)"
      >
        <table class="min-w-full divide-y divide-gray-200 text-left">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-2 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
              <th scope="col" class="px-2 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider">Module Name</th>
              <th scope="col" class="px-2 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider">Notification</th>
              <th scope="col" class="px-2 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider text-right">Action</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            @for (item of notificationItems(); track item.id) {
            <tr
              class="transition-colors"
              [class.cursor-pointer]="item.auditRoute"
              [class.hover:bg-gray-100]="item.auditRoute"
              (click)="navigateToAuditAndCloseModal(item.auditRoute, item.id)"
            >
              <td class="px-2 py-3 text-sm text-gray-700">{{ getNotificationDisplayDate(item) }}</td>
              <td class="px-2 py-3 text-sm text-gray-700">{{ item.moduleName ?? '-' }}</td>
              <td class="px-2 py-3 text-sm text-gray-700 max-w-md">{{ item.message }}</td>
              <td class="px-2 py-3 text-right">
                @if (item.auditRoute) {
                <button
                  type="button"
                  (click)="navigateToAuditAndCloseModal(item.auditRoute, item.id); $event.stopPropagation()"
                  class="text-sm font-medium bg-purple-100 rounded-lg text-purple-600 hover:text-purple-700 px-2 py-1"
                >
                  View
                </button>
                } @else {
                <span class="text-sm text-gray-400">-</span>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
        @if (loadingMoreNotifications()) {
        <div class="flex justify-center py-3">
          <div class="flex items-center gap-2 text-xs text-gray-500">
            <span class="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-gray-600 inline-block"></span>
            <span>Loading older notifications...</span>
          </div>
        </div>
        }
        @if (hasMoreNotifications() && !loadingMoreNotifications()) {
        <div class="flex justify-center py-2 pb-3">
          <button
            type="button"
            (click)="loadMoreNotifications()"
            class="text-xs text-gray-500 hover:text-gray-700 underline"
          >
            Load older notifications
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  }
</header>

<app-confirm-dialog
  [isOpen]="showSwitchConfirm()"
  [title]="switchConfirmTitle"
  [message]="switchConfirmMessage"
  [confirmText]="switchConfirmText"
  [cancelText]="switchCancelText"
  type="danger"
  [closeOnBackdropClick]="true"
  (onConfirm)="onSwitchConfirmProceed()"
  (onCancel)="onSwitchConfirmCancel()"
></app-confirm-dialog>
